export const translations = {
  codigoSap: {
    pt: 'Código SAP',
    en: 'SAP Code',
    es: 'Código SAP',
    de: 'SAP-Code',
  },
  codigo: {
    pt: 'Código',
    en: 'Code',
    es: 'Código',
    de: 'Code',
  },
  descricao: {
    pt: 'Adicione abaixo os códigos SAP referente a esse cliente.',
    en: 'Add the SAP codes below for this client.',
    es: 'Fügen Sie die SAP-Codes für diesen Kunden unten ein.',
    de: 'Fügen Sie unten die SAP-Codes für diesen Kunden hinzu.',
  },
  adicionar: {
    pt: 'Adicionar',
    en: 'Add',
    es: 'Agregar',
    de: 'Hinzufügen',
  },
};
